import { render, staticRenderFns } from "./SelectProductUom.vue?vue&type=template&id=e38f90f6&"
import script from "./SelectProductUom.vue?vue&type=script&lang=ts&"
export * from "./SelectProductUom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e38f90f6')) {
      api.createRecord('e38f90f6', component.options)
    } else {
      api.reload('e38f90f6', component.options)
    }
    module.hot.accept("./SelectProductUom.vue?vue&type=template&id=e38f90f6&", function () {
      api.rerender('e38f90f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectProductUom.vue"
export default component.exports